/* Theme cart drawers update CartCount text without re-rendering the header. */
(() => {
  const sync = () => document.querySelectorAll('.rnl-header .CartCount').forEach(count => {
    count.hidden = !(Number.parseInt(count.textContent, 10) > 0);
  });
  const start = () => {
    sync();
    const cart = document.querySelector('.rnl-header #cart');
    if (cart) new MutationObserver(sync).observe(cart, {childList:true, characterData:true, subtree:true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
